export enum RolaReprezentantaOrganizacji {
  ADM = 'ADM',
  WLA = 'WLA',
  OUP = 'OUP',
}

export const ROLA_REPREZNTANTA_ORGANIZACJI_LABELS: Record<
  RolaReprezentantaOrganizacji,
  string
> = {
  [RolaReprezentantaOrganizacji.ADM]: 'ADMINISTRATOR',
  [RolaReprezentantaOrganizacji.WLA]: 'WŁAŚCICIEL',
  [RolaReprezentantaOrganizacji.OUP]: 'PEŁNOMOCNIK',
};

export function getRolaReprezentantaOrganizacjiDropdownItems() {
  return Object.entries(ROLA_REPREZNTANTA_ORGANIZACJI_LABELS).map(
    ([key, label]) => ({
      label,
      value: key as RolaReprezentantaOrganizacji,
    }),
  );
}

export function getRolaReprezentantaOrganizacjiDropdownItemsWithoutOwner() {
  return getRolaReprezentantaOrganizacjiDropdownItems().filter(
    (item) => item.value !== RolaReprezentantaOrganizacji.WLA,
  );
}

export function getRolaReprezentantaOrganizacjiLabel(
  value: string | null | undefined,
): string {
  if (!value) {
    return '';
  }

  return (
    ROLA_REPREZNTANTA_ORGANIZACJI_LABELS[
      value as RolaReprezentantaOrganizacji
    ] ?? value
  );
}
